import { Emoji } from '@cobu/types';

// Defaults based on old app constants (title, text, color)
export const defaultEmojis: Emoji[] = [
  {
    uuid: 'd877fd51-77b7-47cb-bd8a-d1ae00387e69',
    title: 'like',
    text: '👍',
    animationType: 'zoomInDown',
    meta: { colorScheme: 'rgba(0, 0, 0, 0.5)' },
  },
  {
    uuid: '10f14843-a567-4fcf-90ad-72583962c27a',
    title: 'love',
    text: '❤️',
    animationType: 'bounceInDown',
    meta: { colorScheme: '#F49F00' },
  },
  {
    uuid: '7f3181bb-b6e0-4608-b705-e698e6968cf3',
    title: 'clap',
    text: '👏',
    animationType: 'flash',
    meta: { colorScheme: '#6D89ED' },
  },
  {
    uuid: '4cd931cf-4383-4f95-87b3-da85731c747b',
    title: 'smile',
    text: '😃',
    animationType: 'bounce',
    meta: { colorScheme: '#65000b' },
  },
  {
    uuid: 'af046e88-dc79-4983-8ea2-6756fe460058',
    title: 'laugh',
    text: '😂',
    animationType: 'rotate',
    meta: { colorScheme: '#65000b' },
  },
];

/**
 * Merge two emoji sets, deduping by title. Prefer custom metadata when collided.
 * Stable order: all custom first (in their order), then any missing defaults.
 */
export function mergeEmojiSets(defaults: Emoji[], custom: Emoji[]): Emoji[] {
  const seen = new Set<string>();
  const merged: Emoji[] = [];

  // Add custom first
  for (const e of custom || []) {
    if (!e?.title) continue;
    const key = e.title.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    merged.push(e);
  }

  // Then add defaults not present in custom
  for (const e of defaults || []) {
    if (!e?.title) continue;
    const key = e.title.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    merged.push(e);
  }

  return merged;
} 